/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { a11y, fonts } from '@blend/consumer-components';

const styles = StyleSheet.create({
  message: {
    marginLeft: 7,
    verticalAlign: 'text-bottom',
  },
  inlineText: {
    ...fonts.Roboto,
    lineHeight: '1.5',
    fontSize: 14,
    fontStyle: 'normal',
    textDecorationLine: 'underline',
  },
});

export namespace LinkButtonTextWrapper {
  export interface Props extends React.ButtonHTMLAttributes<HTMLSpanElement> {
    isInlineText?: boolean;
    isInline?: boolean;
  }
}

export const LinkButtonTextWrapper: React.FC<LinkButtonTextWrapper.Props> = ({
  children,
  isInlineText,
  isInline,
  ...htmlProps
}) => {
  const inlineTextStyles = isInlineText ? styles.inlineText : a11y.srOnly;
  return (
    <span className={css(isInline ? inlineTextStyles : styles.message)} {...htmlProps}>
      {children}
    </span>
  );
};
